// https://github.com/nuxt/nuxt/issues/21832#issuecomment-1610982355
// This plugin is to fix a bug with libraries trying to JSON.stringify() objects that have a toJSON method.
export default definePayloadPlugin(() => {
  definePayloadReducer(
    "JSONifiable",
    (data) => data && typeof data === "object" && "toJSON" in data && JSON.stringify(data.toJSON()),
  );
  definePayloadReviver("JSONifiable", (data) => JSON.parse(data));
});
